import { render } from "./WSticker.vue?vue&type=template&id=116394d1&ts=true"
import script from "./WSticker.vue?vue&type=script&lang=ts"
export * from "./WSticker.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__